module.exports = __webpack_public_path__ + "static/media/Planning.d7c0a29d.pdf";